import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc1029',
    ecrans: ['00-2'],
    params: ['id']
});

